import React, { useState } from 'react';
import user_profile from '../../../assets/images/user_profile.jpg';
import like_icon from '../../../assets/images/icon_like.svg';
import msg_icon from '../../../assets/images/icon_message_light.svg';
import delete_icon from '../../../assets/images/icon_delete_msgbox.svg';
import { useSelector } from 'react-redux';
import moment from 'moment';
import ContentLoader from '../../../component/ContentLoader';
import { removeInlineStyle } from '../../../utils';
import { staticImg } from "../../../siteData/users";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ConversionPop = ({ deletePostHandler, postName, postLoading }) => {
    const [openComment, setOpenComment] = useState({})
    const groupDiscussion = useSelector(state => state.groupDiscussionReducer)
    const postHandler = (id) => {
        setOpenComment({ ...openComment, [id]: !openComment[id] })
    }
    return (
        <>
            <div className="group_modal_dialog">
                <div class="courses_details_tab tabs fullWidth">
                    <ul class="list_unstyled">
                        <li><span className="active" style={{ fontSize: '18px' }}>{postName}</span></li>
                    </ul>
                </div>
                {postLoading ?
                    <SkeletonTheme
                        baseColor="#fff"
                        highlightColor="#f5f5f5"
                        borderRadius="0.5rem"
                        duration={4}
                    >
                        {[0, 1, 2, 3, 4].map(_ => <div className="fullWidth mt-5">
                            <div className="messages_box">
                                <div className="messages_box_sender d-flex align-items-center mb-3">
                                    <div className="messages_box_sender_picture">
                                        <Skeleton
                                            circle
                                            height="40px"
                                            width='40px'
                                        />
                                    </div>
                                    <div className="messages_box_sender_name_date pl-4">
                                        <p><Skeleton width='100px' /></p>
                                        <p className="messages_box_sender_name_date_time">
                                            <Skeleton width='100px' />
                                        </p>
                                    </div>
                                </div>
                                <p className="mt-3 text_more">
                                    <Skeleton count={2} />
                                </p>
                                <div className="messages_box_options mt_3">
                                    <ul className="list_unstyled d_flex align_items_center">
                                        <li><Skeleton width='20px' /></li>
                                        <li><div><Skeleton width='20px' /></div></li>
                                        <li><span className="view_comments cursor_pointer"><Skeleton width='100px' /></span></li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                        )}
                    </SkeletonTheme>
                    :
                    <div className="group_chat_messages_box">
                        {groupDiscussion?.map((post, index) => (
                            <div className="fullWidth mt-5">
                                <div className="messages_box">
                                    <div className="messages_box_sender d-flex align-items-center mb-3">
                                        <div className="messages_box_sender_picture">
                                            <img src={staticImg} alt="profile_picture" />
                                        </div>
                                        <div className="messages_box_sender_name_date pl-4">
                                            <p>{post.name}</p>
                                            <p className="messages_box_sender_name_date_time">
                                                {moment(post.updated_at).tz('America/Los_Angeles').format('MMM DD, hh:mm z')}
                                            </p>
                                        </div>
                                    </div>
                                    <p className="mt-3 text_more">
                                        <pre
                                            dangerouslySetInnerHTML={{ __html: removeInlineStyle(post?.bio_raw) }}
                                        />
                                    </p>
                                    <div className="messages_box_options mt_3">
                                        <ul className="list_unstyled d_flex align_items_center">
                                            <li><img src={like_icon} alt="like_icon" /> {post?.like_count}</li>
                                            <li><img src={msg_icon} alt="like_icon" /> {post?.subcomment?.length || 0}</li>
                                            <li><span className="view_comments cursor_pointer" onClick={() => postHandler(post.id)}>View / Hide Comments</span></li>
                                            <div className="delete_icon cursor_pointer"><img src={delete_icon} alt="delete_icon" onClick={() => deletePostHandler(post.id)} /></div>
                                        </ul>
                                    </div>

                                </div>
                                {openComment[post.id] &&
                                    <>
                                        {post?.subcomment?.map((item) => (
                                            <div className="reply_form mt_3">
                                                <div className="messages_box">
                                                    <div className="messages_box_sender d-flex align-items-center mb-3">
                                                        <div className="messages_box_sender_picture">
                                                            <img src={user_profile} alt="profile_picture" />
                                                        </div>
                                                        <div className="messages_box_sender_name_date pl-4">
                                                            <p>{item.name}</p>
                                                            <p className="messages_box_sender_name_date_time">
                                                                {moment(item.updated_at).tz('America/Los_Angeles').format('MMM DD, hh:mm z')}
                                                            </p>
                                                        </div>
                                                        <div className="delete_icon ml_auto cursor_pointer"><img src={delete_icon} alt="delete_icon" onClick={() => deletePostHandler(item.id, 'postPop', index)} /></div>
                                                    </div>
                                                    <p className="mt-3 text_more">
                                                        <pre
                                                            dangerouslySetInnerHTML={{ __html: removeInlineStyle(item?.bio_raw) }}
                                                        />
                                                    </p>

                                                </div>
                                            </div>
                                        ))}

                                    </>}
                            </div>
                        ))}
                    </div>
                }
            </div>
        </>
    )
}

export default ConversionPop
